<template>
  <div id="app">
    <baseHeader />
    <router-view />
    <baseFooter />
  </div>
</template>

<script>
import baseHeader from "@/components/baseHeader.vue";
import baseFooter from "@/components/baserFooter.vue";
export default {
  name: 'App',
  components:{
    baseHeader,
    baseFooter
  }
}
</script>


